import { FormControl, FormGroup } from '@angular/forms';
import {
    ApplyBookingResponseDto,
    BookingSummaryDto,
} from '@opb-workspace/shared';
import {
    bookingNumberDisplayFromSummary,
    coerceBookingSummaryLike,
} from './step2-booking-summary.util';

export type BookingAutocompleteApplyResult =
    | 'cleared'
    | 'skipped_disabled'
    | 'selected';

/** Texto para mostrar el exportador: shipper del booking o, si no viene del SP, nombre de cliente. */
export function exporterLabelFromBookingSummary(
    b: BookingSummaryDto,
): string {
    const ship = (b.shipperName ?? (b as { ShipperName?: string }).ShipperName)
        ?.toString()
        .trim();
    if (ship) return ship;
    const cust = (
        b.customerName ?? (b as { CustomerName?: string }).CustomerName
    )
        ?.toString()
        .trim();
    return cust ?? '';
}

export function exporterLabelWhenRestoringStep2(
    bookingData: ApplyBookingResponseDto | null | undefined,
    bookingId: number | undefined,
    available: BookingSummaryDto[],
): string {
    const fromApply = bookingData?.shipper?.name?.trim();
    if (fromApply) return fromApply;
    if (bookingId == null) return '';
    const sel = available.find((b) => b.bookingId === bookingId);
    return sel ? exporterLabelFromBookingSummary(sel) : '';
}

export function resolveBookingSummaryFromOptionValue(
    v: BookingSummaryDto | null | undefined,
    available: BookingSummaryDto[],
): BookingSummaryDto | null | undefined {
    return coerceBookingSummaryLike(v, available) ?? undefined;
}

export function applyBookingAutocompleteSelection(
    form: FormGroup,
    bookingInputCtrl: FormControl<string | BookingSummaryDto>,
    exporterCtrl: FormControl<string>,
    v: BookingSummaryDto | null | undefined,
    /** Reserva OPB del listado: segunda columna = cliente (portal), no shipper de la reserva. */
    opbExporterDisplayLabel?: string,
): BookingAutocompleteApplyResult {
    if (v === null || v === undefined) {
        form.patchValue({
            selectedBookingId: null,
            bookingNumber: '',
        });
        exporterCtrl.setValue('', { emitEvent: false });
        bookingInputCtrl.setValue('', { emitEvent: false });
        return 'cleared';
    }
    // v2: multiple I/Es per booking allowed — no longer skip on hasActiveShippingInstruction
    form.patchValue({
        selectedBookingId: v.bookingId,
        bookingNumber: bookingNumberDisplayFromSummary(v),
    });
    const exporterLabel =
        (opbExporterDisplayLabel ?? '').trim() ||
        exporterLabelFromBookingSummary(v);
    exporterCtrl.setValue(exporterLabel, {
        emitEvent: false,
    });
    /** Modelo del autocomplete = DTO. Si se guarda solo el string de la etiqueta, displayWith no puede parsearlo y el input queda vacío. */
    bookingInputCtrl.setValue(v, { emitEvent: false });
    return 'selected';
}
